import React from 'react';

interface CustomTableProps {
  children: React.ReactNode;
}

const CustomTable: React.FC<CustomTableProps> = ({ children }) => {
  return (
    <div className="my-6 w-full overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        {children}
      </table>
    </div>
  );
};

export const CustomThead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <thead className="border-b bg-muted/50">
    {children}
  </thead>
);

export const CustomTh: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <th className="border-r last:border-r-0 px-6 py-3 text-left font-medium">
    {children}
  </th>
);

export const CustomTr: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <tr className="border-b last:border-b-0 hover:bg-muted/50 transition-colors">
    {children}
  </tr>
);

export const CustomTd: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <td className="border-r last:border-r-0 px-6 py-3">
    {children}
  </td>
);

export default CustomTable;